import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function removeTopicFromClause(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_CLAUSE_TOPIC_REMOVE,
    (
      organisationId,
      projectId,
      documentId,
      sectionId,
      clauseId,
      clausepartId,
      clausepartLastEdited,
      topicId,
    ) =>
      requestor["delete"](
        `${basePath}/organisation/${organisationId}/project/${projectId}` +
          `/document/${documentId}/clause/${clauseId}` +
          `/clausepart/${clausepartId}/topic/${topicId}`,
        {withCredentials: true, data: {last_edited: clausepartLastEdited}},
      ).then(response => ({
        clause_id: clauseId,
        clausepart_id: clausepartId,
        section_id: sectionId,
        topic_id: topicId,
        ...response.data,
      })),
  );
}
